export const getFileSize = sizeInBytes => {
    if (sizeInBytes < 1024 * 1024) {
        return `${(sizeInBytes / 1024).toFixed(2) } KB`
    }
    return `${(sizeInBytes / (1024 * 1024)).toFixed(2) } MB`
}

/*
* Utility function to get profile image file type.
* @param {string} type - Type of profile image.
* @param {number} index (optional) - Index of profile image.
* @returns {string} - File type of profile image.
*
* This function is used while uploading profile image.
* In case of banner, BE needs file types like banner_1, banner_2 etc.
*/
export const getProfileImageFileType = (type, index) => {
    if (type === 'logo') {
        return 'logo'
    }
    return `banner_${index}`
}
